import {
    getSearchableAsset,
    SearchFilterOption,
    SearchFilterOptionValue,
} from 'owa-timestream-asset-search';
import { mutatorAction } from 'satcheljs';
import { ObservableMap, extendObservable } from 'mobx';
import getStore from '../store';

export const setCurrentSearchPivotKey = mutatorAction(
    'setCurrentSearchPivotKey',
    (searchPivotKey: string) => {
        getStore().currentSearchPivotKey = searchPivotKey;
    }
);

export const setCurrentFilterKey = mutatorAction('setCurrentFilterKey', (filterKey: string) => {
    getStore().currentFilterKey = filterKey;
});

export const updateSearchFilterValue = mutatorAction(
    'updateSearchFilter',
    (filterKey: string, newValue: SearchFilterOptionValue) => {
        const existingFilter = getStore().searchFilters.get(filterKey);
        existingFilter.value = newValue;
    }
);

export const initializeSearchFilters = mutatorAction('initializeSearchFilters', () => {
    getStore().searchFilters = new ObservableMap<string, SearchFilterOption>();
    const searchableAsset = getSearchableAsset(getStore().currentSearchPivotKey);
    const searchFilterOptions = searchableAsset?.getSearchFilterOptions
        ? searchableAsset.getSearchFilterOptions()
        : [];
    searchFilterOptions.forEach(filter => {
        if (filter.value === undefined) {
            // mobx only makes properties observable if they're present on the object when created.
            // force value to be observable here so updates happen appropriately without recreating the whole
            // object in the store every time
            extendObservable(filter, { value: undefined });
        }
        getStore().searchFilters.set(filter.id, filter);
    });
});
